var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowHistoryPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 -4.37114e-08C5.55228 -1.95703e-08 6 0.447715 6 1L6 8L4 8L4 1C4 0.447715 4.44772 -6.78525e-08 5 -4.37114e-08Z",
    fill: "#364863"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76876 11.0781C5.36899 11.5579 4.63214 11.5579 4.23231 11.0782L1.36702 7.64023C0.824192 6.98891 1.28734 6 2.1352 6L7.86512 6C8.71293 6 9.17609 6.9888 8.63338 7.64014L5.76876 11.0781Z",
    fill: "#364863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHistoryPrice);
export default __webpack_public_path__ + "static/media/arrow-history-price.ef6c19c4f62bf12145e1ed799fbc03a4.svg";
export { ForwardRef as ReactComponent };